export const SET_REFERRER = 'loginRequest/SET_REFERRER';

export const defaultState = {
  location: {}
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_REFERRER:
      return {
        ...state,
        location: action.payload || '/'
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/login-request/reducer.js